import { render, staticRenderFns } from "./ProductsEdit.vue?vue&type=template&id=d82a8cce&"
import script from "./ProductsEdit.vue?vue&type=script&lang=ts&"
export * from "./ProductsEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VDivider,VRow,VSkeletonLoader})
